import { NgModule } from '@angular/core';
import { Gw3WebGuidComponent } from './gw3-web-guid.component';
import { TreeViewComponent } from './gw3-guid-test/components/tree-view/tree-view.component';



@NgModule({
  declarations: [Gw3WebGuidComponent, TreeViewComponent],
  imports: [
  ],
  exports: [Gw3WebGuidComponent]
})
export class Gw3WebGuidModule { }
